module.exports = __webpack_public_path__ + "img/Anniversary35C.1f11516b.png";